module.exports = __webpack_public_path__ + "img/medal2.bdc28e1f.svg";